import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Testimonials.css';
import { FaQuoteLeft, FaStar, FaUserCircle } from 'react-icons/fa';

const Testimonials = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-out-cubic',
        });
    }, []);

    const testimonials = [
        {
            id: 1,
            name: "Ahmed Hassan",
            role: "CEO, TechStart Solutions",
            company: "E-commerce Startup",
            rating: 5,
            text: "Working with this developer was an absolute pleasure. He built our e-commerce platform from scratch with exceptional attention to detail. The store is fast, secure, and our conversion rates have increased by 40% since launch. His expertise in both frontend and backend development really shows in the final product.",
            project: "E-commerce Platform Development"
        },
        {
            id: 2,
            name: "Dr. Mohamed Salah",
            role: "Research Supervisor",
            company: "Agricultural Research Institute",
            rating: 5,
            text: "The Cotton Disease Prediction system he developed exceeded our expectations. His deep learning model achieved impressive accuracy, and the web interface makes it accessible to farmers with no technical background. His ability to translate complex AI concepts into practical solutions is remarkable.",
            project: "AI/ML Agricultural Solution"
        },
        {
            id: 3,
            name: "Sarah Ibrahim",
            role: "Restaurant Owner",
            company: "Nile Cuisine Restaurant",
            rating: 5,
            text: "Our restaurant management system has transformed how we operate. The online ordering system is intuitive, the admin dashboard provides valuable insights, and our customers love the seamless experience. He delivered everything on time and provided excellent post-launch support.",
            project: "Restaurant Management System"
        },
        {
            id: 4,
            name: "Khaled Mahmoud",
            role: "Project Manager",
            company: "IEEE Kafr El-Sheikh",
            rating: 5,
            text: "During his internship with us, he demonstrated exceptional technical skills and professionalism. His task management application was well-architected, secure, and delivered ahead of schedule. He's a quick learner who takes initiative and collaborates effectively with the team.",
            project: "Task Management Application"
        },
        {
            id: 5,
            name: "Fatma Ali",
            role: "Marketing Director",
            company: "Digital Growth Agency",
            rating: 5,
            text: "His digital marketing expertise helped us scale multiple client campaigns successfully. He understands both the technical and strategic aspects of online marketing, from social media advertising to conversion optimization. A true professional who delivers measurable results.",
            project: "Digital Marketing Strategy"
        },
        {
            id: 6,
            name: "Omar Youssef",
            role: "Founder",
            company: "StartupHub Egypt",
            rating: 5,
            text: "He provided invaluable consulting for our e-commerce launch strategy. His insights on platform selection, UX optimization, and growth tactics were spot-on. Within three months of implementing his recommendations, we saw a 3x increase in monthly revenue. Highly recommended!",
            project: "E-commerce Consulting"
        }
    ];

    return (
        <section className="testimonials" id="testimonials">
            <div className="testimonials-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
            </div>

            <div className="container testimonials-container">
                <div className="section-header" data-aos="fade-up">
                    <h2 className="section-title">
                        Client <span className="gradient-text">Testimonials</span>
                    </h2>
                    <p className="section-subtitle">
                        What clients and colleagues say about working with me
                    </p>
                </div>

                <div className="testimonials-grid">
                    {testimonials.map((testimonial, index) => (
                        <div
                            className="testimonial-card"
                            key={testimonial.id}
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <div className="quote-icon">
                                <FaQuoteLeft />
                            </div>

                            <div className="rating">
                                {[...Array(testimonial.rating)].map((_, i) => (
                                    <FaStar key={i} className="star-icon" />
                                ))}
                            </div>

                            <p className="testimonial-text">{testimonial.text}</p>

                            <div className="testimonial-project">
                                <span className="project-label">Project:</span>
                                <span className="project-name">{testimonial.project}</span>
                            </div>

                            <div className="testimonial-author">
                                <div className="author-avatar">
                                    <FaUserCircle />
                                </div>
                                <div className="author-info">
                                    <h4 className="author-name">{testimonial.name}</h4>
                                    <p className="author-role">{testimonial.role}</p>
                                    <p className="author-company">{testimonial.company}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
